import React from 'react';
export function EmotionalHeroSection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-pink-light via-baby-cream to-baby-blue-light" data-id="element-390">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-391">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center" data-id="element-392">
          {/* Image */}
          <div className="animate-fade-in-up" data-id="element-393">
            <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow" data-id="element-394">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q8YzhfYH4H3gu8Rf1MBocm/5-mom%E2%80%99s_and_baby%E2%80%99s.png" alt="Mamá feliz con su bebé - Alimentación sin miedo ni culpa" className="w-full h-auto" data-id="element-395" />
            </div>
          </div>

          {/* Content */}
          <div className="animate-fade-in-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-396">
            <div className="bg-white/90 backdrop-blur-baby p-8 sm:p-10 rounded-baby-lg border-2 border-baby-lavender shadow-baby-glow" data-id="element-397">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 bg-gradient-to-r from-baby-pink via-baby-lavender to-baby-blue bg-clip-text text-transparent" data-id="element-398">
                Alimenta a tu bebé sin miedo ni culpa
              </h2>

              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-6" data-id="element-399">
                Con recetas probadas para el día a día
              </p>

              <div className="space-y-4" data-id="element-400">
                <div className="flex items-start gap-3 bg-baby-blue-light/50 p-4 rounded-baby" data-id="element-401">
                  <span className="text-2xl flex-shrink-0" data-id="element-402">✓</span>
                  <p className="text-sm sm:text-base text-gray-800 font-medium" data-id="element-403">
                    <strong data-id="element-404">Ingredientes claros</strong> - Todo lo que necesitas
                    está en tu cocina
                  </p>
                </div>

                <div className="flex items-start gap-3 bg-baby-pink-light/50 p-4 rounded-baby" data-id="element-405">
                  <span className="text-2xl flex-shrink-0" data-id="element-406">✓</span>
                  <p className="text-sm sm:text-base text-gray-800 font-medium" data-id="element-407">
                    <strong data-id="element-408">Pasos simples</strong> - Sin complicaciones ni
                    técnicas difíciles
                  </p>
                </div>

                <div className="flex items-start gap-3 bg-baby-blue-light/50 p-4 rounded-baby" data-id="element-409">
                  <span className="text-2xl flex-shrink-0" data-id="element-410">✓</span>
                  <p className="text-sm sm:text-base text-gray-800 font-medium" data-id="element-411">
                    <strong data-id="element-412">Texturas por edad</strong> - Sabrás exactamente qué
                    es seguro
                  </p>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t-2 border-baby-lavender" data-id="element-413">
                <p className="text-lg sm:text-xl font-bold text-center text-gray-900" data-id="element-414">
                  Porque tu bebé merece comida casera, y tú mereces tranquilidad
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}